// extracted by mini-css-extract-plugin
module.exports = {"container":"ChildCheckable_container__17TjO","txt":"ChildCheckable_txt__3qC2z","checkbox":"ChildCheckable_checkbox__19V9k"};